export default {
  'device.auth':'Device Auth Page'
}
